<div class="profile-preview flex-align-center" nz-dropdown nzTrigger="click" [nzDropdownMenu]="profileMenu">
  <nz-avatar 
    [nzShape]="'square'" 
    [ngStyle]="{background: 'rgba(45, 198, 79, 0.15)', color: '#2DC64F'}" 
    [nzText]="firstLetter | wrapFn : appStore.$user().fullName"
  ></nz-avatar>
</div>

<nz-dropdown-menu #profileMenu="nzDropdownMenu">
  <ul nz-menu>
    <div class="dropdown-user">
      <div class="user-preview flex-align-center">
        <nz-avatar [nzShape]="'square'" [ngStyle]="{background: 'rgba(45, 198, 79, 0.15)', color: '#2DC64F'}" [nzSize]="50"
          [nzText]="firstLetter | wrapFn : appStore.$user().fullName"></nz-avatar>

        <div class="user-preview__content flex-column">
          <strong class="user-preview__name">{{appStore.$user().fullName}}</strong>
          <span class="user-preview__role">{{'roles.' + EUserRole[userRole()] | translate}}</span>
        </div>
      </div>
    </div>
    <li nz-menu-divider class="user-dropdown-divider"></li>
    <li nz-menu-item>
      <img class="icon" src="/assets/icons/profile-icon.svg" width="24" height="24" alt="Profile icon" />
      {{'profile.buttons.my-profile' | translate}}
    </li>
    <li nz-menu-item (click)="logout()">
      <img class="icon" src="/assets/icons/sign-out-icon.svg" width="24" height="24" alt="Sign Out icon" />
      {{'profile.buttons.sign-out' | translate}}
    </li>
  </ul>
</nz-dropdown-menu>
